// test2117
(2117 && 0);
